var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProgramColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#002C8B",
    d: "M37.2 37.2V2H2v43.2A4.8 4.8 0 0 0 6.8 50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#002C8B",
    d: "M11.6 45.2A4.8 4.8 0 0 1 6.8 50h32a4.8 4.8 0 0 0 4.8-4.8V42h-32v3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B5E1",
    d: "M10 13.2h19.2M10 22h19.2M10 30.8h19.2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramColor);
export default __webpack_public_path__ + "static/media/program-color.bcd4800f.svg";
export { ForwardRef as ReactComponent };